import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';

import LogoUrl from '../../../../resources/logo.svg';
import DownloadIconUrl from '../../../../resources/icons/icon-download-black.svg';
import MenuIconUrl from '../../../../resources/icons/menu.svg';
import ZoomIconUrl from '../../../../resources/icons/icon-zoom-black.svg';
import parse  from '../../../../utils/parse'

import {
  DOWNLOAD_TEXT,
  MENU_DESKTOP_WIDTH,
  PRESENTATION_TEXT,
  LINKS,
  PDF_MENU,
  WEBSITE_URL,
  PDF_NAME_HR,
  TEXT_LINKS,
  WEB_LINKS,
} from '../../../../config';

import ShareButton from './ShareButton';
import GifPreviewDialog from './GifPreviewDialog';

import styles from '../styles';

class DesktopAppMenu extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      currentHighlightedItem: null,
      isHover: false,
      gifDialogItem: null,
      quickMenuOpen: false,
    }
  }
  /**
   * HANDLE
   */
  isMenuItemActive(item, page) {
    if (!item?.pages?.length) {
      return false;
    }

    const [start, end = start] = item.pages;
    return page >= start && page <= end;
  }

  handleQuickMenuToggle() {
    this.setState((prev) => ({ quickMenuOpen: !prev.quickMenuOpen }));
  }

  handleQuickMenuNavigate(item) {
    const { onNavigate } = this.props;
    this.setState({ quickMenuOpen: false });
    onNavigate(item.pages[0]);
  }

  handleMouseEnter(evt, params = null) {
    const setState = {
      isHover: true,
    };
    if (params) {
      setState.currentHighlightedItem = params;
    }
    this.setState(setState);
  }

  handleMouseLeave(evt) {
    const { relatedTarget, toElement } = evt.nativeEvent;
    if (relatedTarget) {
      if (relatedTarget.classList.contains('bookmarkButton')) {
        return;
      }
      if (relatedTarget.closest('.subDrawer')) {
        return;
      }
    }
    if (toElement) {
      if (toElement.classList.contains('bookmarkButton')) {
        return;
      }
      if (toElement.closest('.subDrawer')) {
        return;
      }
    }
    this.setState({ isHover: false });
  }

  /**
   * RENDER
   */

  renderText(item) {
    if (!item) return null;
    const { classes } = this.props;
    const sections = [
      { label: 'CLIENT', key: 'client' },
      { label: 'ACTIVITÉ', key: 'secteur' },
      { label: 'MILLÉSIMES', key: 'miles' },
      { label: 'CONCEPT', key: 'concept' },
      { label: 'LIVRABLE', key: 'livrable' },
    ];

    return (
      <div className={classes.textRoot}>
        {sections.map(({ label, key }) => {
          const value = item[key];
          if (!value) return null;

          return (
            <div key={key} className={classes.Menublock}>
              <Typography
                variant="overline"
                component="p"
                className={classes.Menulabel}
              >
                {label}
              </Typography>

              <Typography
                variant={key === 'concept' || key === 'livrable' ? 'body2' : 'body1'}
                className={classes.Menuvalue}
              >
                {parse(value)}
              </Typography>
            </div>
          );
        })}
      </div>
    );
  }

  renderVideo(item) {
    if (!item) return null;
    const { classes } = this.props;
    const isAbsolute = /^https?:\/\//i.test(item.url);
    const isGif = item.isGif ?? item.url.toLowerCase().endsWith('.gif');
    const isMp4 = item.isVideo ?? item.url.toLowerCase().endsWith('.mp4');

    let src = item.url;

    if (!isAbsolute) {
      const publicUrl = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
      const mediaFolder = isGif ? 'gifs' : isMp4 ? 'videos' : '';
      const normalizedSrc = src.replace(/^\/+/, '');
      const mediaPath = mediaFolder && !normalizedSrc.startsWith(`${mediaFolder}/`) ? `${mediaFolder}/${normalizedSrc}` : normalizedSrc;
      src = `${publicUrl}/${mediaPath}`;
    }
    return (
      <>
        {isGif ? (
          <>
            <button
              type="button"
              className={classes.gifButton}
              onClick={() => this.setState({ gifDialogItem: { src, alt: item.title || 'Animation' } })}
              aria-label="Agrandir l'animation"
            >
              <img
                src={src}
                alt={item.title || 'Animation'}
                className={classes.gifImage}
              />
              <span className={classes.gifOverlay} aria-hidden="true">
                <span className={classes.gifOverlayIconWrapper}>
                  <img src={ZoomIconUrl} alt="" className={classes.gifOverlayIcon} />
                </span>
              </span>
            </button>
            <GifPreviewDialog
              classes={classes}
              open={this.state.gifDialogItem?.src === src}
              src={src}
              alt={item.title || 'Animation'}
              onClose={() => this.setState({ gifDialogItem: null })}
            />
          </>
        ) : isMp4 ? (
          <video
            src={src}
            controls
            autoPlay
            muted
            loop
            playsInline
            poster={item.poster || undefined} // optionnel
            className={classes.video}
            style={{ maxWidth: '100%', height: 'auto' }}
          >
            Votre navigateur ne supporte pas la vidéo HTML5.
          </video>
        ) : (
          <Typography className={classes.buttonDrawerParagraph}>
            <a
              href={item.url}
              className={classes.mainDrawerHeaderLink}
              target={isAbsolute ? '_blank' : undefined}
              rel={isAbsolute ? 'noreferrer' : undefined}
            >
              {item.title || item.url}
            </a>
          </Typography>
        )}
      </>
    )
  }

  renderWebLink(item) {
    if (!item?.url) return null;
    const { classes } = this.props;

    return (
      <div className={classes.Menublocklink}>
        <Typography
          component="a"
          href={item.url}
          target="_blank"
          rel="noreferrer"
          className={classes.menuWebLink}
        >
          Voir le site
        </Typography>
      </div>
    );
  }

  renderMainDrawer() {
    const { classes, page } = this.props;
    const { quickMenuOpen } = this.state;
    const item = LINKS[page];
    const item_text = TEXT_LINKS[page];
    const webLinkItem = WEB_LINKS[page];
    return (
      <div className={classes.mainDrawer}>
        <Box className={classes.mainDrawerHeader} sx={{ flexGrow: 1 }}>
          <a href={WEBSITE_URL} target="_blank" rel="noopener noreferrer" style={{display: 'block'}}>
            <img src={LogoUrl} alt="LUCIOLE" />
          </a>
          {!!PDF_MENU.length && (
            <>
              <Button
                className={`${classes.quickMenuToggle} ${quickMenuOpen ? 'active' : ''}`}
                onClick={() => this.handleQuickMenuToggle()}
                startIcon={<img className={classes.menuIcon} src={MenuIconUrl} alt="" aria-hidden="true" />}
              >
                Menu
              </Button>
            </>
          )}
          {(page >= 1 && page <= 3) && (
            <Typography className={classes.mainDrawerParagraph}>
              {PRESENTATION_TEXT}
            </Typography>
          )}
          {this.renderText(item_text)}
          {this.renderWebLink(webLinkItem)}
          {this.renderVideo(item)}
        </Box>

        <Stack className={classes.socialList} justifyContent='center' style={{ paddingBottom: '32px' }}>
          <Stack>
            <ShareButton classes={classes} />
            <ListItem key="download" className={classes.listItem} disablePadding>
              <ListItemButton
                onClick={() => {
                  // Event for Downloads stat with analytics
                  // window.gtag('event', 'download_pdf', {
                  //   'event_category': 'Luciole',
                  //   'event_label': 'download_pdf_click'
                  // });
                  const link = document.createElement("a");
                  // link.href = fileURL;
                  link.href = `${window.location.pathname}${PDF_NAME_HR}`;
                  link.download = 'LUCIOLE-Portfolio-sante-2026.pdf';
                  link.click();
                  if (window.umami) {
                    window.umami.track('Portfolio Santé 2026 - Download');
                  }
                }}
              >
                <ListItemIcon>
                  <img className={classes.menuIcon} src={DownloadIconUrl} alt={DOWNLOAD_TEXT} />
                </ListItemIcon>
                <ListItemText className={`${classes.drawerLabel}`} primary={<Typography variant="h4">{DOWNLOAD_TEXT}</Typography>} />
              </ListItemButton>
            </ListItem>
          </Stack>
        </Stack>
      </div>
    );
  }

  render() {
    const { classes, fullscreen, page } = this.props;
    const { quickMenuOpen } = this.state;
    return (
      <>
        <Stack
          className={classes.desktopMenuContainer}
          sx={{ width: fullscreen ? 0 : MENU_DESKTOP_WIDTH }}
          direction="row"
        >
          {this.renderMainDrawer()}
        </Stack>
        <Box className={`${classes.subDrawerOverlay} ${!fullscreen && quickMenuOpen ? 'open' : ''}`}>
          <Box className={classes.subDrawerPaper}>
            <Typography className={classes.subDrawerHeader}>
              Menu
            </Typography>
            <Box className={classes.subDrawerContent}>
              <Stack className={classes.quickMenuList}>
                {PDF_MENU.map((menuItem) => (
                  <Button
                    key={menuItem.label}
                    className={`${classes.quickMenuItem} ${this.isMenuItemActive(menuItem, page) ? 'active' : ''}`}
                    onClick={() => this.handleQuickMenuNavigate(menuItem)}
                  >
                    <Typography>{menuItem.label}</Typography>
                  </Button>
                ))}
              </Stack>
            </Box>
          </Box>
        </Box>
      </>
    );
  }
}

DesktopAppMenu.defaultProps = {
  page: 0,
};

DesktopAppMenu.propTypes = {
  // props
  fullscreen: PropTypes.bool,
  page: PropTypes.number,
  fileURL: PropTypes.string,
  // funcs
  onNavigate: PropTypes.func.isRequired,
};

export default withStyles(styles)(DesktopAppMenu);
